import React, { useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { Box, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import ViewRestaurant from "../../screens/ViewRestaurant/ViewRestaurant";
// import SearchMenu from "../../screens/SearchMenu/SearchMenu";
import { useHistory } from "react-router-dom";
import DishCard from "../../screens/ViewRestaurant/Card";
import * as api from "../../api/index.js";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "5px",
    // width: "100%",
    flexGrow: 1,
  },

  Grid: {
    padding: theme.spacing(2),
    maxWidth: 500,
    margin: "5px",
    justifyContent: "left",
    textAlign: "left",
  },

  closeButton: {
    position: "absolute",
    top: "10px",
    right: "15px",
  },

  paper: {
    padding: theme.spacing(2),
    margin: "auto",
    maxWidth: 500,
    borderRadius: "15px",
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      justifyContent: "center",
      width: "230px",
    },
  },

  image: {
    width: "150px",
    minHeight: " 120px",
    maxHeight: "auto",
    float: "left",
    margin: " 3px",
    padding: "3px",
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      justifyContent: "center",
      width: "250px",
      // width:'100%'
    },
  },
  img: {
    height: 130,
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      justifyContent: "center",
      width: 250,
      // width:'100%'
    },
  },

  description: {
    fontFamily: "SegoeUI-Light, Segoe UI",
    fontWeight: 300,
    width: 350,
    textAlign: "left",
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      justifyContent: "center",
      width: "100%",
    },
  },

  price: {
    textAlign: "right",
    fontSize: 12,
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      width: 260,
      fontSize: 15,
    },
  },
  calories: {
    textAlign: "left",
    fontSize: 12,
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      width: 260,
      fontSize: 15,
    },
  },
  linkButton: {
    fontFamily: "Gilroy-Light, serif",
    fontSize: "14px",
    textTransform: "capitalize",
    color: "#d62828",
    marginRight: "10px",
    "&:hover": {
      backgroundColor: "transparent",
    },
    "& .MuiBox-root": {
      fontSize: "14px",
    },
  },

  viewMenu: {
    [theme.breakpoints.down("xs")]: {
      textAlign: "left",
      width: 260,
      fontSize: 15,
      margnTop: "10px",
    },
  },
  chip: {
    margin: 1,
    //justifyContent: "center",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
}));

// const DialogTitle = withStyles(styles)((props) => {
//   // eslint-disable-line
//   const { children, classes, onClose, ...other } = props;
//   return (
//     <MuiDialogTitle disableTypography className={classes.root} {...other}>
//       <Typography variant="h6">{children}</Typography>

//       {onClose ? (
//         <IconButton
//           aria-label="close"
//           className={classes.closeButton}
//           onClick={onClose}
//         >
//           <CloseIcon />
//         </IconButton>
//       ) : null}
//     </MuiDialogTitle>
//   );
// });

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

// const DialogActions = withStyles((theme) => ({
//   // eslint-disable-line
//   root: {
//     margin: 0,
//     padding: theme.spacing(1),
//   },
// }))(MuiDialogActions);

export default function CustomizedDialogs(props) {
  const classes = useStyles();

  let history = useHistory();

  const { values, open, closeModal } = props;
  const [items, setItems] = React.useState([]);
  const [name, setName] = React.useState("");
  // const [viewMenu, setViewMenu] = React.useState(false);

  const handleClose = (value) => {
    //setClose(false)
  };

  // useEffect(() => {
  //   if(open){
  //     <SearchMenu open={open}/>
  //   }
  // }, [open])

  const loadRestaurant = () => {
    let type;

    if (type === "restaurant") {
      history.push("/restaurant", { id: props.values.restaurantId });
    }
    //else{
    //   history.push('/search', { location })
    // }
    <ViewRestaurant loadRestaurant={loadRestaurant} />;
  };

  const get = async () => {
    try {
      var current = new Date();
      values.date = current.toLocaleDateString();
      const data = await api.searchResults(values);

      setItems(data.data.data);
      setName(data.data.name);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (open && values) {
      get();
    }
  }, [open, values]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <Dialog
        PaperProps={{
          style: { borderRadius: 25 },
        }}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth="sm"
      >
        <Grid xs={12} sm={12} md={12}>
          <Grid>
            <Grid xs={12} sm={12} md={12} lg={12}>
              {/* <DialogTitle
                id="customized-dialog-title"
                onClose={handleClose}
              ></DialogTitle> */}
              <CloseIcon
                onClick={() => closeModal()}
                className={classes.closeButton}
              />
            </Grid>
            <Grid
              alignItems="center"
              container
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ padding: "30px 15px 20px 15px" }}
            >
              <Grid item xs={12} sm={8} md={8}>
                <Typography variant="h5" component="h2">
                  {items[0] && items[0].restaurantId ? (
                    <Box
                      fontWeight="fontWeightBold"
                      fontSize={16}
                    >{`${name} - ${items[0].restaurantId.name} `}</Box>
                  ) : (
                    ""
                  )}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sm={4}
                md={4}
                container
                justify="flex-end"
                margin={0}
              >
                {" "}
                <Button
                  onClick={loadRestaurant}
                  startIcon={<MenuBookIcon />}
                  className={classes.linkButton}
                >
                  <Box
                    display="inline"
                    fontSize={10}
                    onClick={() => {
                      history.push(`/restaurant/${values.restaurantId}/view`, {
                        id: values.restaurantId,
                      });
                    }}
                    className={classes.viewMenu}
                  >
                    View full menu
                  </Box>
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <DialogContent dividers>
          <Grid container spacing={2}>
            {items.map((item) => {
              return (
                <Grid item container xs={12} sm={12} md={12} lg={12} xl={12}>
                  <DishCard
                    classes={classes}
                    item={item}
                    gets={get}
                    res={false}
                  />
                </Grid>
              );
            })}
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}
//
